export default __webpack_public_path__ + "static/media/EmptyState_V2.0cd0ba70.png";